import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";

const MainModel = ({
  header,
  openVar,
  children,
  buttonTitle,
  buttonFunc,
  closeFunc,
  isLoading = false,
  size = "4xl",
  extraButtons,
  contentProps,
  headerProps,
  bodyProps,
  footerProps,
  hideDefaultFooter = false,
  cancelTitle = "Cancel",
}) => {
  const { onClose } = useDisclosure();

  return (
    <Modal
      isOpen={openVar}
      onClose={onClose}
      closeOnOverlayClick={true}
      size={size}
    >
      <ModalOverlay />
      <ModalContent bg="white" {...contentProps}>
        <ModalHeader {...headerProps}>{header}</ModalHeader>
        <ModalBody {...bodyProps}>{children}</ModalBody>
        {!hideDefaultFooter && (
          <ModalFooter
            justifyContent="center"
            flexDirection="column"
            gap={4}
            {...footerProps}
          >
            {extraButtons && extraButtons}
            {buttonTitle && (
              <Button
                isLoading={isLoading}
                onClick={() => buttonFunc()}
                color="white"
                bg="#8B1828"
                borderRadius="12px"
                fontWeight="800"
                minH="44px"
                px={8}
                minW="200px"
                type="submit"
                boxShadow="0 10px 24px rgba(139, 24, 40, 0.28)"
                _hover={{ bg: "#7A1422" }}
                _active={{ bg: "#6B121F" }}
                _focus={{ outline: "none", boxShadow: "0 0 0 3px rgba(122, 20, 34, 0.35)" }}
              >
                {buttonTitle}
              </Button>
            )}
            <Button
              onClick={closeFunc}
              variant="outline"
              borderRadius="12px"
              fontWeight="800"
              minH="44px"
              px={8}
              borderColor="#D6CEC0"
              color="#7A1422"
              bg="rgba(255,255,255,0.72)"
              minW="200px"
              _hover={{ bg: "white", borderColor: "#7A1422" }}
              _focus={{ outline: "none", boxShadow: "0 0 0 3px rgba(122, 20, 34, 0.18)" }}
            >
              {cancelTitle}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default MainModel;
